// pages/MainPage.tsx
import React, { useEffect, useState } from 'react';
import NetWorthCard from '../components/NetWorthCard';
import TransactionsTable from '../components/TransactionsTable';
import { AccountTotal, fetchTotals } from '../services/totalsService';
import { fetchTransactions, filterRecentTransactions, TransactionFilters } from '../services/transactionsService';
import { Transaction } from '../helpers/HelperInterfaces';
import { DEFAULT_USER_ID } from '../helpers/HelperConstants';


interface MainPageProps {
  accountsMap: Record<string,string>;
  onSeeMore: () => void;
}

let transactionFilter = new TransactionFilters(10);

const MainPage: React.FC<MainPageProps> = ({ accountsMap, onSeeMore }) => {
  const [totals, setTotals]               = useState<AccountTotal[]>([]);
  const [totalsLoading, setTotalsLoading] = useState(true);
  const [totalsError, setTotalsError]     = useState<string | null>(null);

  const [transactions, setTransactions]               = useState<Transaction[]>([]);
  const [transactionsLoading, setTransactionsLoading] = useState(true);
  const [transactionsError, setTransactionsError]     = useState<string | null>(null);

  useEffect(() => {
    fetchTotals(DEFAULT_USER_ID)
      .then(setTotals)
      .catch((err: Error) => setTotalsError("Failed to get your totals. Please try again later."))
      .finally(() => setTotalsLoading(false));
  }, []);

  useEffect(() => {
    setTransactionsLoading(true);
    fetchTransactions(DEFAULT_USER_ID, 1, transactionFilter)
      .then(([data, _]) => setTransactions(filterRecentTransactions(data)))
      .catch((err: Error) => setTransactionsError("Failed to get your transactions. Please try again later."))
      .finally(() => setTransactionsLoading(false));
  }, []);

  return (
    <>
      <NetWorthCard
        totals={totals}
        loading={totalsLoading}
        error={totalsError}
      />

      <TransactionsTable
        transactions={transactions}
        accountsMap={accountsMap}
        loading={transactionsLoading}
        error={transactionsError}
        onSeeMore={onSeeMore}
      />
    </>
  );
};

export default MainPage;
